import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import type { SessionMeta } from '../types';

interface UseSessionsOpts {
  status?: string;
  specId?: string;
  q?: string;
}

interface UseSessionsReturn {
  sessions: SessionMeta[];
  total: number;
  loading: boolean;
  error: string | null;
  reload: () => void;
}

export function useSessions(opts: UseSessionsOpts): UseSessionsReturn {
  const [sessions, setSessions] = useState<SessionMeta[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [reloadKey, setReloadKey] = useState(0);

  const reload = useCallback(() => setReloadKey((k) => k + 1), []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .listSessions({ ...opts, limit: 200 })
      .then((res) => {
        if (cancelled) return;
        setSessions(res.sessions);
        setTotal(res.total);
        setError(null);
      })
      .catch((err: unknown) => {
        if (!cancelled) setError(String(err));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [opts.status, opts.specId, opts.q, reloadKey]);

  return { sessions, total, loading, error, reload };
}
